module.exports = __webpack_public_path__ + "static/woocommerce_monei-029189423f8e8e2475cf923188c6176e.svg";